// For Firebase JS SDK v7.20.0 and later, measurementId is optional

import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';


const firebaseConfig = {
    apiKey: "AIzaSyCIVWOTxGO2_n8mmsLKoP3I6X1PEztgj5Y",
    authDomain: "clone-1f37e.firebaseapp.com",
    projectId: "clone-1f37e",
    storageBucket: "clone-1f37e.appspot.com",
    messagingSenderId: "972865750372",
    appId: "1:972865750372:web:7b75e6ac6dda8c9b69e671",
    measurementId: "G-C280156N7W"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { db, auth };